// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalNotification_container__1ysLR"};